import React from "react";
import { observer } from "mobx-react";

import { Button, Typography } from "@material-ui/core";

import LoadingButton from "components/LoadingButton";

import {
  ButtonWrapper,
  Container,
  Controls,
  InnerContent,
  TitleContainer,
} from "./style";

type Props = {
  className?: any;
  children?: React.ReactNode;

  title: string;
  text?: string;

  acceptText: string;
  declineText?: string;

  isLoading?: boolean;

  onAccept: () => void;
  onDecline?: () => void;
};

@observer
export default class ConfirmationDialog extends React.Component<Props> {
  render() {
    const {
      className,
      children,
      title,
      text,
      acceptText,
      declineText,
      isLoading,
      onAccept,
      onDecline,
    } = this.props;

    return (
      <Container className={className}>
        <TitleContainer>
          <Typography variant="h1">{title}</Typography>
        </TitleContainer>
        {text?.split("\n").map((str, index) => (
          <Typography variant="subtitle1" key={`${str}-${index}`}>
            {str}
          </Typography>
        ))}

        {children && <InnerContent>{children}</InnerContent>}

        <Controls>
          {declineText && onDecline && (
            <ButtonWrapper>
              <Button
                onClick={onDecline}
                variant="outlined"
                color="primary"
                fullWidth
              >
                {declineText}
              </Button>
            </ButtonWrapper>
          )}

          <ButtonWrapper>
            <LoadingButton
              onClick={onAccept}
              isLoading={isLoading}
              variant="contained"
              color="primary"
              fullWidth
            >
              {acceptText}
            </LoadingButton>
          </ButtonWrapper>
        </Controls>
      </Container>
    );
  }
}
